/* eslint-disable max-classes-per-file */

export class CacheStore {
  static _default: CacheStore | undefined;

  static get default(): CacheStore {
    if (!CacheStore._default) {
      CacheStore._default = new CacheStore();
    }
    return CacheStore._default;
  }

  // eslint-disable-next-line no-useless-constructor
  constructor(private _stores = new Map<string, ObjectCache>()) {}

  delete(cacheName: string): boolean {
    return this._stores.delete(cacheName);
  }

  has(cacheName: string): boolean {
    return this._stores.has(cacheName);
  }

  keys(): string[] {
    return Array.from(this._stores.keys());
  }

  open<M>(cacheName: string): ObjectCache<M> {
    let store = this._stores.get(cacheName);
    if (!store) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      store = new ObjectCache<M>();
      this._stores.set(cacheName, store);
    }
    return store;
  }

  enable(cacheName: string) {
    this.open(cacheName);
  }

  get<M>(cacheName: string): ObjectCache<M> | undefined {
    if (this.has(cacheName)) {
      return this.open<M>(cacheName);
    }
    return undefined;
  }
}

// type CacheItem<M> = [string, M];
interface CacheItemTuple<M> extends Array<string | M> {
  0: string;
  1: M;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class ObjectCache<M = any> {
  // eslint-disable-next-line no-useless-constructor
  constructor(private _store = new Map<string, M>()) {}

  get(key: string) {
    return this._store.get(key);
  }

  add(key: string, value: M) {
    this._store.set(key, value);
  }

  addAll(items: CacheItemTuple<M>[]) {
    const store = this._store;
    items.forEach(arr => {
      if (Array.isArray(arr)) {
        const [key, value] = arr;
        if (key != null) {
          store.set(`${key}`, value);
        }
      }
    });
  }

  delete(key: string): boolean {
    return this._store.delete(key);
  }

  keys(): ReadonlyArray<string> {
    return Array.from(this._store.keys());
  }

  put(key: string, value: M) {
    if (!this._store.has(key)) {
      this._store.set(key, value);
    }
  }
}
